import LuxonUtils from '@date-io/luxon';
const luxon = new LuxonUtils();

export const formatDate = (date, format = 'MMM dd, yyyy H:mm a') => {
    return luxon.date(date).toFormat(format);
}